export const TIPOLOGIEDOC = {
  CODICE_FISCALE: "CF",
  CARTA_DI_IDENTITà: "CI",
  PASSAPORTO: "PASS",
  PATENTE: "PI",
};
